import React, { cloneElement, createRef, isValidElement, useContext, useLayoutEffect, } from 'react';
import { PopoverContext } from './PopoverContext';
export const PopoverTrigger = ({ children: trigger, dataTest }) => {
    const { openPopover, setOpenPopover, setContentTop, setContentBottom, setTriggerLeft, setTriggerRight, } = useContext(PopoverContext);
    const triggerRef = createRef();
    useLayoutEffect(() => {
        var _a;
        if (!((_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.children))
            return () => { };
        const triggerElement = triggerRef.current.children[0];
        const calculateTriggerPositions = () => {
            const { top: triggerElementTop, right: triggerElementRight, left: triggerElementLeft, bottom: triggerElementBottom, } = triggerElement.getBoundingClientRect();
            setContentTop(Math.round(triggerElementBottom));
            setContentBottom(Math.round(window.innerHeight - triggerElementTop));
            setTriggerLeft(Math.round(triggerElementLeft));
            setTriggerRight(Math.round(triggerElementRight));
        };
        const calculateTriggerPositionsAnimationFrame = window.requestAnimationFrame(calculateTriggerPositions);
        window.addEventListener('resize', calculateTriggerPositions);
        return () => {
            window.cancelAnimationFrame(calculateTriggerPositionsAnimationFrame);
            window.removeEventListener('resize', calculateTriggerPositions);
        };
    });
    if (isValidElement(trigger)) {
        return (React.createElement("div", { ref: triggerRef, "data-test": dataTest }, cloneElement(trigger, {
            onClick: () => {
                setOpenPopover(!openPopover);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (trigger.props.onClick) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                    trigger.props.onClick();
                }
            },
        })));
    }
    return React.createElement(React.Fragment, null);
};
PopoverTrigger.POPOVER_ELEMENT = 'trigger';
//# sourceMappingURL=PopoverTrigger.js.map